module.exports = __webpack_public_path__ + "media/images/bg/shapes/hex-big-light-orange-c9239111294532ef91ae1e46d79a0cf7.svg";